import React from "react";
import * as styles from "./HeroWrapper.module.css";
import { HeroHeights, HeroStyles } from "../../../types";

export interface SolidHeroProps {
  style?: HeroStyles;
  height?: HeroHeights;
}

export const SolidHeroWrapper: React.FC<SolidHeroProps> = ({
  style,
  height,
  ...props
}) => {
  const containerClasses = [styles.hero];
  height === "tall"
    ? containerClasses.push(styles.tall)
    : containerClasses.push(styles.short);
  style === "light_background"
    ? containerClasses.push(styles.turquoise)
    : containerClasses.push(styles.navy);

  return (
    <div className={containerClasses.join(" ")}>
      <div className={styles.heroContentWrap}>{props.children}</div>
    </div>
  );
};
